import React from 'react';
import { Show, FunctionField, ReferenceArrayField, SingleFieldList, SimpleShowLayout, required, number, minValue, 
    Toolbar, SaveButton, AutocompleteArrayInput, BooleanInput, NumberField, DateField, NumberInput, TabbedForm, FormTab, 
    SelectArrayInput, ArrayInput, SimpleFormIterator, Edit, Create, EditButton, Filter, List, Datagrid, TextField, 
    TextInput, ReferenceArrayInput, SelectInput, BooleanField, ReferenceField, FormDataConsumer, AutocompleteInput,
    ReferenceInput, ChipField, Button} from 'react-admin';
import { Box, Card, CardContent, CardHeader } from '@material-ui/core';
import {
  TopLevelDomainFilter, PublisherFilter, DeviceTypeFilter, SegmentFilter, IABCategoriesFilter, 
  PageUrlFilter, CountryFilter, StateFilter, DivIDFilter, ViewabilityFilter, OSFilter,
  ChannelFilter, ImpressionTypeFilter, PlacementFilter
} from './common/filters/Filters';
import WarningIcon from '@material-ui/icons/WarningRounded';
import { makeStyles } from '@material-ui/core/styles';
const {validInteger, validFrequencyCap, validFrequencyHours} = require('./components/validation.js');
const utils = require('./components/utils');

const CampaignTitle = ({ record }) => {
    return <span>
        {record && record.name ? `Edit Campaign "${record.name}" ${record.active ? 'ACTIVE' : 'INACTIVE'}` : 'Create Campaign' }
    </span>
    ;
};

const CampaignFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
        <BooleanInput source="owned" defaultValue='true' label="Owned By Me" style={{ color: 'white' }} resettable />
        <BooleanInput source="active" defaultValue='true' label="Active" style={{ color: 'white' }} resettable />
        {props?.permissions?.role !== 'advertiser' &&
        <ReferenceArrayInput source="advertiser_id"
            reference="advertisers"
            basePath='advertisers'
            perPage={10}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}>
            <AutocompleteArrayInput label="Advertisers" optionText="name" optionValue="code" style={{ width: '90%' }} />
        </ReferenceArrayInput>
        }
    </Filter>
);
const FilterArrayField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (!record.segment || !record.segment[field] || !record.segment[field].values || record.segment[field].values.length<=0) {
    return <div><br /><label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
      <span>{label} [Not set]</span>
    </label></div>;
  }
	var arr = record.segment[field].values.split('\n');
	return (
		<div>
	 		<br />
	 		<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
	 			<span>{label} {record.segment[field].exclude ? '[EXCLUDE]' : ''}</span>
	 		</label>
	 		<br />
	 		<span className="MuiTypography-root MuiTypography-body2">
	 			{arr.length > 5 ? (arr.splice(0, 5).join(' ') + ' ...') : arr.join(' ')}
	 		</span>
	</div>
	)
}
const FilterListField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (record.segment && record.segment[field] && record.segment[field].values && record.segment[field].values.length>0) {return (
		<div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label} {record.segment[field].exclude ? '[EXCLUDE]' : ''}</span>
			</label>
			<ul>
				{record.segment[field].values.map(item => (
					<li key={item}>{item}</li>
				))}
			</ul>
		</div>
	) } else return (
    <div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label} [Not set]</span>
			</label>
		</div>
  )
	return <div />
}

const CampaignPreview = props => {
	return (
		<Show {...props} actions={false}>
			<SimpleShowLayout>
                {props.record.pace != null && <NumberField label="Pace %" source="pace" />}
				{props.record.frequency_cap != null && <span>Frequency Cap</span>}
				{props.record.frequency_cap != null && <NumberField label="Cap" source="frequency_cap.cap" />}
				{props.record.frequency_cap != null && <NumberField label="Hours" source="frequency_cap.hours" />}
        {props.record.advertiser_id != null && props.parent?.permissions?.role!=='advertiser' && <ReferenceField label="Advertiser" source="advertiser_id" reference="advertisers">
					<TextField source="name" /></ReferenceField>}
                {props.record.creatives != null && 
                    <ReferenceArrayField reference="creatives" source="creatives" label="Selected Creatives">
                        <SingleFieldList><FunctionField render={record => ` > ${record.name}`} /></SingleFieldList>
                    </ReferenceArrayField>}
				<FilterArrayField field='filter_top_level_domain' label='Filter Domains'/>
				<FilterArrayField field='filter_page_url' label='Filter Page URLs'/>
				<FilterListField field='filter_country' label='Filter Countries'/>
				<FilterListField field='filter_state' label='Filter States'/>
				<FilterListField field='filter_device_type' label='Filter Devices'/>
				{/* <FilterArrayField field='filter_adsize' label='Filter Ad Sizes'/> */}
				<FilterArrayField field='filter_divid' label='Filter Div IDs'/>
        <FilterListField field='filter_viewability' label='Filter Viewability' />
        {<FilterListField field='filter_os' label='Filter Operating Systems' />}
			</SimpleShowLayout>
		</Show>
	)
}
export const AdCampaignList = (props) => (
  <List {...props} title="Campaigns" 
    filter={{ type: ['DIRECT', 'PERFORMANCE'] }}
    filters={<CampaignFilter {...props} />} 
    perPage={25} 
    bulkActionButtons={false}>
		<Datagrid rowClick="edit" expand={<CampaignPreview parent={props}/>}>
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
			<TextField source="pace" label="Pace %" />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<BooleanField source="active" label="Active" />
			<EditButton variant="contained" color="primary" />
		</Datagrid>
	</List>
);

const CustomToolbar = props => (
	<Toolbar {...props}>
		<SaveButton /> 
		<br />
		<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
		<TextField source="updated_name" label="" style={{ padding: '10px' }} />
	</Toolbar>
);
const timezones = [
{id: 'Pacific/Pago_Pago', name: '(GMT-11:00) Pacific/Pago_Pago'},
{id: 'Pacific/Honolulu', name: '(GMT-10:00) Pacific/Honolulu'},
{id: 'America/Los_Angeles', name: '(GMT-08:00) America/Los_Angeles'},
{id: 'America/Denver', name: '(GMT-07:00) America/Denver'},
{id: 'America/Chicago', name: '(GMT-06:00) America/Chicago'},
{id: 'America/New_York', name: '(GMT-05:00) America/New_York'},
{id: 'America/Halifax', name: '(GMT-04:00) America/Halifax'},
{id: 'America/Argentina/Buenos_Aires', name: '(GMT-03:00) America/Argentina/Buenos_Aires'},
{id: 'Atlantic/South_Georgia', name: '(GMT-02:00) Atlantic/South_Georgia'},
{id: 'Atlantic/Azores', name: '(GMT-01:00) Atlantic/Azores'},
{id: 'Europe/London', name: '(GMT+00:00) Europe/London'},
{id: 'Central European Time', name: '(GMT+01:00) Central European Time'},
{id: 'Asia/Jerusalem', name: '(GMT+02:00) Asia/Jerusalem'},
{id: 'Europe/Istanbul', name: '(GMT+03:00) Europe/Istanbul'},
{id: 'Asia/Baku', name: '(GMT+04:00) Asia/Baku'},
{id: 'Asia/Tashkent', name: '(GMT+05:00) Asia/Tashkent'},
{id: 'Asia/Dhaka', name: '(GMT+06:00) Asia/Dhaka'},
{id: 'Asia/Bangkok', name: '(GMT+07:00) Asia/Bangkok'},
{id: 'Asia/Shanghai', name: '(GMT+08:00) Asia/Shanghai'},
{id: 'Asia/Tokyo', name: '(GMT+09:00) Asia/Tokyo'},
{id: 'Pacific/Guam', name: '(GMT+10:00) Pacific/Guam'},
{id: 'Australia/Sydney', name: '(GMT+11:00) Australia/Sydney'},
{id: 'Pacific/Majuro', name: '(GMT+12:00) Pacific/Majuro'},
{id: 'Pacific/Fiji', name: '(GMT+13:00) Pacific/Fiji'}
];

const useStyles = makeStyles({
  dualGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '15px'
  },
  
  flexColumn: {
    display: 'flex',
    flexDirection: 'column'
  }
});
const progressStyle = {
  width: '100px',
  height: '13px',
  border: '2px solid silver'
};
function progress (nom, denom) {
  const color = nom <= denom ? '#00ff7f' : 'orangered';
  return (denom > 0) ? <span style={{color: color, whiteSpace: 'nowrap'}}>Progress: {utils.double(100 * nom / denom, '%')}<br/><progress style={progressStyle} value={nom} max={denom} /></span> : '';
}
function active (metric) {
  return metric ? '' : <div style={{fontSize: 'xx-small', textAlign: 'center', color: 'orangered'}}>PAUSED<br/><WarningIcon style={{color: 'orangered'}}/></div>;
}
class AdCampaignForm extends React.Component {
  render () {
    const permissions = this.props.permissions;
    return (
      <TabbedForm toolbar={<CustomToolbar />} {...this.props}>
        <FormTab label="Settings">
          <TextField source="code" label="Campaign ID" />
          <div style={{ width: '100%' }}>
          <div style={{ width: '45%', display: 'inline-block', verticalAlign: 'top' }}>
              <Card raised>
                  <CardContent {...this.props}>
                  <BooleanInput source="active" label="Active" defaultValue={false} validate={required()} />
                  {permissions.role !== 'advertiser' &&
                  <TextInput source="name" label="Campaign Name" style={{ width: '400px' }} validate={required()} />
                  }
                  {permissions.role === 'advertiser' && [
                  <div>Campaign Name</div>,
                  <TextField source="name" label="Campaign Name" />
                  ]
                  }
                  {permissions.role !== 'advertiser' &&
                  <div style={{ width: '30%' }}>
                  <ReferenceInput label="Advertiser *"
                      perPage={15}
                      sort={{ field: 'name', order: 'ASC' }}
                      filterToQuery={searchText => ({ search_name: searchText })}
                      source="advertiser_id"
                      reference="advertisers"
                      basePath='advertisers' defaultValue={101} fullWidth >
                      <AutocompleteInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""} 
                      optionValue='code' validate={required()} sx={{ width: 1/2 }} />
                  </ReferenceInput>
                  </div>
                  }
                  {permissions.role !== 'advertiser' &&
                  <SelectInput label="Type" source="type" initialValue='DIRECT' 
                  choices={[
                      {id: 'DIRECT', name: 'DIRECT / CPC'},
                      {id: 'PERFORMANCE', name: 'PERFORMANCE'}
                  ]} />
                  }
                  {permissions.role === 'advertiser' && [
                  <br/>,<br/>,
                  <div>Type</div>,
                  <TextField label="Type" source="type" />
                  ]
                  }
                  <br/>
                  <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
                  <BooleanInput source='retargeting_enabled' label='Retargeting Enabled'/>
                  <FormDataConsumer>
                  {({ formData }) => (formData.retargeting_enabled) && [
                  <NumberInput source='retargeting_price_rate' defaultValue={50} label='% Retargeting Price Rate' helperText='Retargeting Price Percentage Rate %' 
                  validate={[number(), minValue(1)]} style={{ width: '30%'}} step={1} />,
                  <FunctionField render={() => (formData.retargeting_price_rate && formData.bid_price) ? 
                    <div style={{marginLeft: '10px', marginTop: '23px'}}>Calculated Retargeting Bid Price: ${formData.bid_price/100 * formData.retargeting_price_rate}</div>
                    : '' } />
                  ]}
                  </FormDataConsumer>
                  </Box>

                  {permissions.role !== 'advertiser' &&
                  <ReferenceArrayInput label="Select Creatives *"
                      perPage={15}
                      sort={{ field: 'name', order: 'ASC' }}
                      filterToQuery={searchText => ({ search_name: searchText })}
                      source="creatives"
                      reference="creatives"
                      basePath='creatives'
                      style={{ width: '50%' }}
                      >
                      <AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code}) [${record.width}x${record.height}]` : ""} 
                      optionValue="code" style={{ width: '50%' }} validate={required()}/>
                  </ReferenceArrayInput>
                  }
                  {permissions.role === 'advertiser' && [
                    <br/>,
                    <div>Selected Creatives *</div>, <br/>,
                    <ReferenceArrayField 
                    reference='creatives' 
                    source='creatives' 
                    basePath='/creatives'
                    label="Select Creatives *">
                        <SingleFieldList><ChipField source="name" /></SingleFieldList>
                    </ReferenceArrayField>
                  ]
                  }
                  </CardContent>
              </Card>
          </div>
          <div style={{ width: '45%', display: 'inline-block', verticalAlign: 'top', paddingLeft: '20px' }}>
              <Card raised>
                  <CardContent>
                  {permissions.role !== 'advertiser' &&
                  <FormDataConsumer>
                  {({ formData }) => (formData.type === 'DIRECT') && [
                      <NumberInput label="Bid Price (USD $)" source={'bid_price'} validate={[required(), number(), minValue(0.01)]} style={{ width: '50%'}} />,
                      <br/>,
                      <table style={{width: '50%'}}><tr><td style={{width: '70%'}}><NumberInput label="Hourly Spend Limit (USD $)" source="hourly_revenue_limit" validate={[required(), number(), minValue(0.01)]} style={{ width: '100%'}}/></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '22px'}}><FunctionField render={record => progress(record.current_spend, record.hourly_revenue_limit) } /></td>
                      </tr></table>,
                      <br/>,
                      <table style={{width: '50%'}}><tr><td style={{width: '70%'}}><NumberInput label="Daily Spend Limit (USD $)" source="daily_revenue_limit" validate={[number(), minValue(0.01)]} style={{ width: '100%'}}/></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '22px'}}><FunctionField render={record => progress(record.current_daily_revenue, record.daily_revenue_limit)} /></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '15px'}}><FunctionField render={record => active(record.daily_revenue_limit_active)} /></td>
                      </tr></table>,
                      <br/>,
                      <table style={{width: '50%'}}><tr><td style={{width: '70%'}}><NumberInput label="Lifetime Gross Spend Limit (USD $)" source="lifetime_revenue_limit" validate={[number(), minValue(0.01)]} style={{ width: '100%'}}/></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '22px'}}><FunctionField render={record => progress(record.current_lifetime_revenue, record.lifetime_revenue_limit) } /></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '15px'}}><FunctionField render={record => active(record.lifetime_revenue_limit_active)} /></td>
                      </tr></table>,
                      <br/>,
                      <table style={{width: '60%'}}><tr><td style={{width: '70%'}}><NumberInput label="Lifetime Impressions Limit" source="lifetime_impressions_limit" validate={[number(), minValue(1)]} style={{ width: '100%'}} step={1}/></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '22px'}}><FunctionField render={record => progress(record.current_lifetime_impressions, record.lifetime_impressions_limit) } /></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '15px'}}><FunctionField render={record => active(record.lifetime_impressions_limit_active)} /></td>
                      </tr></table>,
                      <br/>,
                      <NumberInput label="Booked CPM Price (USD $)" source="campaign_book_price" style={{ width: '50%'}} step={0.01}/>,
                      ]
                  }
                  </FormDataConsumer>
                  }
                  <FormDataConsumer>{({ formData }) => (formData.type === 'PERFORMANCE') && [
                      <SelectInput source="priority" label="Priority" initialValue={"1"}
                      choices={[{id:12, name: 'HIGH'}, {id:11, name: 'MEDIUM'}, {id:10, name: 'LOW'}]}/>
                      ]
                  }</FormDataConsumer>
                  {permissions.role !== 'advertiser' && [
                    <br/>,
                    <NumberInput label="Hourly Clicks Limit" source="hourly_clicks_limit" step={1} validate={[number(), minValue(0), validInteger]} style={{ width: '50%'}}/>,
                    <br/>,
                    <NumberInput label="Daily Clicks Limit" source="daily_clicks_limit" step={1} validate={[number(), minValue(0), validInteger]} style={{ width: '50%'}}/>,
                    <br/>,
                    <NumberInput label="CPC Price (USD $)" source="cpc_price" style={{ width: '50%'}}/>
                  ]
                  }
                  {permissions.role === 'advertiser' && [
                    <br/>,<br/>,
                    <div>Booked Total Impressions</div>,
                    <table style={{width: '70%'}}><tr><td style={{width: '30%'}}><NumberField label="Booked Total Impressions" source="lifetime_impressions_limit" style={{ width: '100%'}}/></td>
                    <td style={{textAlign: 'left', paddingLeft: '10px'}}><FunctionField render={record => progress(record.current_lifetime_impressions, record.lifetime_impressions_limit) } /></td>
                    <td style={{paddingTop: '10px'}}><FunctionField render={record => active(record.lifetime_impressions_limit_active)} /></td>
                    </tr></table>,
                    <br/>,<br/>,
                    <div>Booked CPM Price (USD $)</div>,
                    <NumberField label="Booked CPM Price (USD $)" source="campaign_book_price" style={{ width: '50%'}}/>,
                  ]
                  }
                  </CardContent>
              </Card>
          </div>
          </div>
          <br/><br/>
          <TextInput source="type" defaultValue='DIRECT' disabled style={{ visibility: 'hidden', display: 'none' }}/>

          {permissions.role !== 'advertiser' && [<table border="0" style={{textWrap: 'nowrap', borderSpacing: '15px', border: '1px solid silver'}}>
          <tr>
            <td><FunctionField render={record => `Hour Gross Spend: ${utils.double(record.current_spend || 0)}`} /></td>
            <td><FunctionField render={record => `Hour Impressions: ${utils.long(record.current_impressions || 0)}`} /></td>
            <td><FunctionField render={record => progress(record.current_spend, record.hourly_revenue_limit) } /></td>
            <td></td>
          </tr>
          <tr>
            <td><FunctionField render={record => `Today's Gross Spent: ${utils.double(record.current_daily_revenue || 0)}`} /></td>
            <td><FunctionField render={record => `Today's Impressions: ${utils.long(record.current_daily_impressions || 0)}`} /></td>
            <td><FunctionField render={record => progress(record.current_daily_revenue, record.daily_revenue_limit)} /></td>
            <td style={{paddingTop: '10px'}}><FunctionField render={record => active(record.daily_revenue_limit_active)} /></td>
          </tr>
          <tr>
            <td><FunctionField render={record => `Lifetime Gross Spent: ${utils.double(record.current_lifetime_revenue || 0)}`} /></td>
            <td><FunctionField render={record => `Lifetime Ad Spend: ${utils.double(record.current_lifetime_adspend || 0)}`} /></td>
            <td><FunctionField render={record => progress(record.current_lifetime_revenue, record.lifetime_revenue_limit) } /></td>
            <td style={{paddingTop: '10px'}}><FunctionField render={record => active(record.lifetime_revenue_limit_active)} /></td>
          </tr>
          <tr>
            <td><FunctionField render={record => `Lifetime Impressions: ${utils.long(record.current_lifetime_impressions || 0)}`} /></td>
            <td><FunctionField render={record => `Lifetime Impressions Limit: ${utils.long(record.lifetime_impressions_limit || 0)}`} /></td>
            <td><FunctionField render={record => progress(record.current_lifetime_impressions, record.lifetime_impressions_limit) } /></td>
            <td style={{paddingTop: '10px'}}><FunctionField render={record => active(record.lifetime_impressions_limit_active)} /></td>
          </tr>
          <tr>
            <td><FunctionField render={record => `Hour clicks: ${record.current_clicks || 0}`} /></td>
            <td><FunctionField render={record => `Today's Clicks: ${record.current_daily_clicks || 0}`} /></td>
            <td><FunctionField render={record => `Today's CTR: ${(record.current_impressions>0) ? ((record.current_clicks||0)/record.current_impressions).toFixed(5) : 0}`} /></td>
            <td style={{paddingTop: '10px'}}><FunctionField render={record => active(record.daily_clicks_limit_active)} /></td>
          </tr>
          </table>
          ]
          }

          {permissions.role === 'advertiser' && [<table style={{textWrap: 'nowrap', borderSpacing: '15px'}}>
          <tr>
          <td><FunctionField render={record => `Lifetime Impressions: ${utils.long(record.current_lifetime_impressions || 0)}`} addLabel={false} style={{width: '100%'}} /></td>
          <td><FunctionField render={record => progress(record.current_lifetime_impressions, record.lifetime_impressions_limit) } style={{width: '100%'}} /></td>
          <td style={{paddingTop: '10px'}}><FunctionField render={record => active(record.lifetime_impressions_limit_active)} /></td>
          </tr>
          <tr><td><FunctionField addLabel={false} render={record => `Lifetime Ad Spend: ${utils.double(record.current_lifetime_adspend || 0)}`} /></td></tr>
          </table>
          ]
          }

          {permissions.role !== 'advertiser' &&
            <ReferenceArrayField 
            reference='creatives' 
            source='creatives' 
            basePath='/creatives'
            label="Selected Creatives">
                <SingleFieldList><TextField source="name" /></SingleFieldList>
            </ReferenceArrayField>
          }
          <br/>

        </FormTab>
        <FormTab label="Limits">
            
            <br/>
            <SelectInput label="Campaign Pace" source="pace" initialValue='100' choices={utils.PACES} />

            <br/>
            <Card style={{ width: '50%' }} raised>
                <CardHeader title="Frequency Capping" />
                <CardContent>
                    <table>
                        <tr>
                            <td><NumberInput label="Cap" source="frequency_cap.cap" min={0} step={1} validate={validFrequencyCap} /></td>
                            <td><div style={{ width: '10px' }}> </div></td>
                            <td><NumberInput label="Hours" source="frequency_cap.hours" min={0} max={168} step={1} validate={validFrequencyHours} /></td>
                        </tr>
                    </table>
                </CardContent>
            </Card>
            <br/>
            <div>Day Parting</div>
            <ArrayInput source="day_parting_config">
                <SimpleFormIterator>
                <SelectInput source='timezone' label="Select Timezone..." choices={timezones} 
                    defaultValue="America/New_York" style={{ width: '350px' }}/>
                <SelectArrayInput source="days" label="Any Day" choices={[
                    { id: 2, name: 'Monday' },
                    { id: 3, name: 'Tuesday' },
                    { id: 4, name: 'Wednesday' },
                    { id: 5, name: 'Thursday' },
                    { id: 6, name: 'Friday' },
                    { id: 7, name: 'Saturday' },
                    { id: 1, name: 'Sunday' }
                    ]} style={{ width: '350px' }} />
                <SelectArrayInput style={{ width: '350px' }} source="hours" label="Any Hour" choices={[
                    { id: 0, name: '0:00 AM Midnight' },
                    { id: 1, name: '1:00 AM' },
                    { id: 2, name: '2:00 AM' },
                    { id: 3, name: '3:00 AM' },
                    { id: 4, name: '4:00 AM' },
                    { id: 5, name: '5:00 AM' },
                    { id: 6, name: '6:00 AM' },
                    { id: 7, name: '7:00 AM' },
                    { id: 8, name: '8:00 AM' },
                    { id: 9, name: '9:00 AM' },
                    { id: 10, name: '10:00 AM' },
                    { id: 11, name: '11:00 AM' },
                    { id: 12, name: '12:00 PM' },
                    { id: 13, name: '1:00 PM' },
                    { id: 14, name: '2:00 PM' },
                    { id: 15, name: '3:00 PM' },
                    { id: 16, name: '4:00 PM' },
                    { id: 17, name: '5:00 PM' },
                    { id: 18, name: '6:00 PM' },
                    { id: 19, name: '7:00 PM' },
                    { id: 20, name: '8:00 PM' },
                    { id: 21, name: '9:00 PM' },
                    { id: 22, name: '10:00 PM' },
                    { id: 23, name: '11:00 PM' }
                    ]} />
                </SimpleFormIterator>
            </ArrayInput>
        </FormTab>
        <FormTab label="Filters">
          <Box className={this.props.classes.dualGrid} fullWidth record={this.props.record}>
            <Box className={this.props.classes.flexColumn} fullWidth>
              { permissions.role !== 'advertiser' && <PublisherFilter {...this.props}/> }
              { permissions.role !== 'advertiser' && <SegmentFilter {...this.props}/> }
              
              { permissions.role !== 'advertiser' && <TopLevelDomainFilter {...this.props}/> }
              { permissions.role === 'advertiser' && <FilterArrayField {...this.props} field='filter_top_level_domain' label='Top Level Domains'/>}

              { permissions.role !== 'advertiser' && <PageUrlFilter {...this.props}/> }
              { permissions.role === 'advertiser' && <FilterArrayField {...this.props} field='filter_page_url' label='Page URLs'/>}

              { permissions.role !== 'advertiser' && <ChannelFilter {...this.props} defaultValues={['web', 'amp']} /> }
              { permissions.role === 'advertiser' && <FilterListField {...this.props} field='filter_channel' label='Channels'/>}

              { permissions.role !== 'advertiser' && <DivIDFilter {...this.props}/> }
              { permissions.role === 'advertiser' && <FilterArrayField {...this.props} field='filter_divid' label='Div IDs'/>}

              { permissions.role !== 'advertiser' && <PlacementFilter {...this.props}/> }
              { permissions.role === 'advertiser' && <FilterListField {...this.props} field='filter_placement' label='Placements'/>}
            </Box>
            <Box className={this.props.classes.flexColumn} fullWidth>
              { permissions.role !== 'advertiser' && <CountryFilter {...this.props}/> }
              { permissions.role === 'advertiser' && <FilterListField {...this.props} field='filter_country' label='Countries'/>}

              { permissions.role !== 'advertiser' && <StateFilter {...this.props}/> }
              { permissions.role === 'advertiser' && <FilterListField {...this.props} field='filter_state' label='States'/>}

              { permissions.role !== 'advertiser' && <DeviceTypeFilter {...this.props}/> }
              { permissions.role === 'advertiser' && <FilterListField {...this.props} field='filter_device_type' label='Devices'/>}

              { permissions.role !== 'advertiser' && <ViewabilityFilter {...this.props}/> }
              
              { permissions.role !== 'advertiser' && <OSFilter {...this.props}/> }
              { permissions.role === 'advertiser' && <FilterListField {...this.props} field='filter_os' label='Operating Systems'/>}
              
              { permissions.role !== 'advertiser' && <ImpressionTypeFilter {...this.props} defaultValues={['BANNER']}/> }
              { permissions.role !== 'advertiser' && <IABCategoriesFilter {...this.props}/> }
            </Box>
          </Box>

          {/* <TextInput source="segment.filter_impression_type.match_type" initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
          <BooleanInput source="segment.filter_impression_type.exclude" initialValue={false} disabled style={{ width: '1%', visibility: 'hidden', display: 'none' }} />
          <TextInput source="segment.filter_impression_type.values" initialValue={['BANNER']} disabled style={{ width: '1%', visibility: 'hidden', display: 'none' }} /> */}

        </FormTab>
      </TabbedForm>
    )
  }
}

export const AdCampaignEdit = ({ permissions, ...props }) => {
  const classes = useStyles(props);
  return (
    <Edit title={<CampaignTitle />} mutationMode="pessimistic" {...props}>
      <AdCampaignForm formType="edit" permissions={permissions} classes={classes} {...props}/>
    </Edit>
  )
}

export const AdCampaignCreate = ({ permissions, ...props }) => {
  const classes = useStyles(props);
  return (
    <Create title={<CampaignTitle />} mutationMode="pessimistic" {...props}>
      <AdCampaignForm formType="edit" permissions={permissions} classes={classes} {...props}/>
    </Create>
  )
}
